<ion-content>
  <app-templates></app-templates>
</ion-content>
